import { useMemo } from 'react';

import { usePrimeModalProps } from '../../module/PrimeModalProvider';

export function useCustomAction(applicationId: string) {
  const { actions } = usePrimeModalProps();
  const action = useMemo(() => {
    return actions.find((act) => act.applicationId === applicationId)?.action;
  }, [actions, applicationId]);
  return action;
}
